import { H2, TextL } from '~/tenset-components'

export function FurtherRoadmap() {
  return (
    <div className="flex flex-col items-center justify-center text-center max-w-screen-lg mx-auto gap-4">
      <H2 isBold>Further Development</H2>

      <TextL>
        Stay tuned for more updates. The cryptocurrency market is exceptionally
        dynamic, and to remain pioneers, we must also be adaptable. Together,
        let&apos;s create the next chapters of innovation.
      </TextL>
    </div>
  )
}
